/**
 * @author       yontaek@zumper.com (Yon Taek Chung)
 * @copyright    Copyright (c) 2023, Zumper
 * @description  Constants for Ratings and Reviews data module
 */

export const CLEAR_RATING_AND_REVIEWS_DATA =
  '@@nzr/ratingsAndReviews/CLEAR_RATING_AND_REVIEWS_DATA' as const
export const DONE_FETCHING_RATING_AND_REVIEWS_DATA =
  '@@nzr/ratingsAndReviews/DONE_FETCHING_RATING_AND_REVIEWS_DATA' as const
export const ERROR_FETCHING_RATING_AND_REVIEWS_DATA =
  '@@nzr/ratingsAndReviews/ERROR_FETCHING_RATING_AND_REVIEWS_DATA' as const
export const RECEIVE_RATING_AND_REVIEWS_DATA =
  '@@nzr/ratingsAndReviews/RECEIVE_RATING_AND_REVIEWS_DATA' as const
export const START_FETCHING_RATING_AND_REVIEWS_DATA =
  '@@nzr/ratingsAndReviews/START_FETCHING_RATING_AND_REVIEWS_DATA' as const

export const CLEAR_MODAL_RATING_AND_REVIEWS_DATA =
  '@@nzr/ratingsAndReviews/CLEAR_MODAL_RATING_AND_REVIEWS_DATA' as const
export const DONE_FETCHING_MODAL_RATING_AND_REVIEWS_DATA =
  '@@nzr/ratingsAndReviews/DONE_FETCHING_MODAL_RATING_AND_REVIEWS_DATA' as const
export const ERROR_FETCHING_MODAL_RATING_AND_REVIEWS_DATA =
  '@@nzr/ratingsAndReviews/ERROR_FETCHING_MODAL_RATING_AND_REVIEWS_DATA' as const
export const RECEIVE_MODAL_RATING_AND_REVIEWS_DATA =
  '@@nzr/ratingsAndReviews/RECEIVE_MODAL_RATING_AND_REVIEWS_DATA' as const
export const START_FETCHING_MODAL_RATING_AND_REVIEWS_DATA =
  '@@nzr/ratingsAndReviews/START_FETCHING_MODAL_RATING_AND_REVIEWS_DATA' as const

export const CLEAR_MODAL_RATING_AND_REVIEWS_COUNTS_DATA =
  '@@nzr/ratingsAndReviews/CLEAR_MODAL_RATING_AND_REVIEWS_COUNTS_DATA' as const
export const DONE_FETCHING_MODAL_RATING_AND_REVIEWS_COUNTS_DATA =
  '@@nzr/ratingsAndReviews/DONE_FETCHING_MODAL_RATING_AND_REVIEWS_COUNTS_DATA' as const
export const ERROR_FETCHING_MODAL_RATING_AND_REVIEWS_COUNTS_DATA =
  '@@nzr/ratingsAndReviews/ERROR_FETCHING_MODAL_RATING_AND_REVIEWS_COUNTS_DATA' as const
export const RECEIVE_MODAL_RATING_AND_REVIEWS_COUNTS_DATA =
  '@@nzr/ratingsAndReviews/RECEIVE_MODAL_RATING_AND_REVIEWS_COUNTS_DATA' as const
export const START_FETCHING_MODAL_RATING_AND_REVIEWS_COUNTS_DATA =
  '@@nzr/ratingsAndReviews/START_FETCHING_MODAL_RATING_AND_REVIEWS_COUNTS_DATA' as const
